import api from '@/api/index'

// 退货地址详情
export function getReturnAddressInfo(params) {
    return api({
        url: '/api/shop/returnAddress/info',
        method: 'get',
        params
    })
}

// 退货地址编辑
export function editReturnAddress(data) {
    return api({
        url: '/api/shop/edit/returnAddress',
        method: 'post',
        data
    })
}

// 获取支持的物流
export function getSupportExpress(params) {
    return api({
        url: '/api/shop/express/support',
        method: 'get',
        params
    })
}

// 获取已配置的物流
export function getAvailableExpress(params) {
    return api({
        url: '/api/shop/express/available',
        method: 'get',
        params
    })
}

// 运费模版列表
export function getExpressFeeList(params) {
    return api({
        url: '/api/shop/express/fee/list',
        method: 'get',
        params
    })
}

// 运费模版添加
export function addExpressFee(data) {
    return api({
        url: '/api/shop/express/fee/add',
        method: 'post',
        data
    })
}

// 运费模版删除
export function delExpressFee(data) {
    return api({
        url: '/api/shop/express/fee/del',
        method: 'post',
        data
    })
}

// 获取资金流水
export function getFundLogList(params) {
    return api({
        url: '/api/user/credit/log/list',
        method: 'get',
        params
    })
}

// 获取可提现、不可提现记录列表
export function getFreezeList(params) {
    return api({
        url: '/api/user/freeze/log/list',
        method: 'get',
        params
    })
}

// 提现申请
export function applyWithdraw(data) {
    return api({
        url: '/api/user/withdraw/apply',
        method: 'post',
        data
    })
}

// 提现列表
export function getWithdrawList(params) {
    return api({
        url: '/api/user/withdraw/list',
        method: 'get',
        params
    })
}
